// import Tank2valve from "../../assets/img/jadid-2taii.png";
import TankPic from "../../assets/img/waterTank.png";
import BottomErr from "../../assets/img/10.png";
import TopErr from "../../assets/img/01.png";
import AllOk from "../../assets/img/11.png";
import "./waterTank.css";
const WaterTank = ({ data, info }) => {
  const up_sensor = info.other_information?.up_sensor;
  const down_sensor = info.other_information?.down_sensor;
  const sensor_position = info.other_information?.position;
  const waterHeight = ((sensor_position - data.value) * 100) / sensor_position;
  const waterStyles = {
    height: `${waterHeight}%`,
  };
  const renderSensore = () => {
    if (
      up_sensor &&
      up_sensor !== 0 &&
      sensor_position - data.value > up_sensor
    ) {
      // s
      return TopErr;
    } else if (
      down_sensor &&
      down_sensor !== 0 &&
      sensor_position - data.value < down_sensor
    ) {
      return BottomErr;
    } else {
      return AllOk;
    }
  };
  return (
    <>
      <div className="live-image-box">
        <div className="wave-container" style={waterStyles}>
          <svg
            className="waves"
            viewBox="0 24 150 28"
            preserveAspectRatio="none"
            shapeRendering="auto"
          >
            <defs>
              <path
                id="gentle-wave"
                d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
              />
            </defs>
            <g className="parallax">
              <use
                xlinkHref="#gentle-wave"
                x="48"
                y="0"
                fill="rgba(6,6,230,0.7)"
              />
              <use
                xlinkHref="#gentle-wave"
                x="48"
                y="3"
                fill="rgba(6,6,230,0.5)"
              />
              <use
                xlinkHref="#gentle-wave"
                x="48"
                y="5"
                fill="rgba(6,6,230,0.3)"
              />
              <use
                xlinkHref="#gentle-wave"
                x="48"
                y="7"
                fill="rgba(6,6,230,0.1)"
              />
            </g>
          </svg>
        </div>
        <div className="tank-container">
          <img src={TankPic} alt="tank_image" />
        </div>
        <div className="sensor-container">
          <img src={renderSensore()} alt="sensor_image" />
        </div>
      </div>
    </>
  );
};
export default WaterTank;
